import React from 'react';
import styled from 'styled-components';

import { DataElementContext } from '../../common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

const StateListItemDiv = styled.div((props) => props.$styleText);

export const StateListItem = (componentProps) => {
  let props = componentProps;

  const dataElementContext = React.useContext(DataElementContext);
  let isVisible = true;

  [props, isVisible] = processComponentProps(props, dataElementContext);

  if (!isVisible) {
    return null;
  }

  return (
    <StateListItemDiv className={props.className ?? ''} $styleText={props.styleText} style={props.style}>
      {componentProps.children}
    </StateListItemDiv>
  );
};
